import { getQuoteTypeOptions } from '@paintscout/util/builder/options'
import type { OptionsDocument } from 'paintscout'

export function getProjectTypeLabel(type: string, options: OptionsDocument) {
  const quoteTypes = getQuoteTypeOptions({ options, hideAll: false })
  const matchedType = quoteTypes.find((t) => t.key === type)
  return matchedType ? matchedType.label : ''
}
